export default "/_next/static/media/enjoei-collectionwidget1-1024x404.e5d7266c6934ad8171f63350382dd4d9.png";